import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';

const BarCodeIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M16.375 4.875C16.375 4.32272 16.8227 3.875 17.375 3.875H21.125C21.6773 3.875 22.125 4.32272 22.125 4.875V8.625C22.125 9.17728 21.6773 9.625 21.125 9.625C20.5727 9.625 20.125 9.17728 20.125 8.625V5.875H17.375C16.8227 5.875 16.375 5.42728 16.375 4.875Z"
        fill={iconColor}
      />
      <Path
        d="M3.875 14.375C4.42728 14.375 4.875 14.8227 4.875 15.375V18.125H7.625C8.17728 18.125 8.625 18.5727 8.625 19.125C8.625 19.6773 8.17728 20.125 7.625 20.125H3.875C3.32272 20.125 2.875 19.6773 2.875 19.125V15.375C2.875 14.8227 3.32272 14.375 3.875 14.375Z"
        fill={iconColor}
      />
      <Path
        d="M22.125 15.375C22.125 14.8227 21.6773 14.375 21.125 14.375C20.5727 14.375 20.125 14.8227 20.125 15.375V18.125H17.375C16.8227 18.125 16.375 18.5727 16.375 19.125C16.375 19.6773 16.8227 20.125 17.375 20.125H21.125C21.6773 20.125 22.125 19.6773 22.125 19.125V15.375Z"
        fill={iconColor}
      />
      <Path
        d="M2.875 4.875C2.875 4.32272 3.32272 3.875 3.875 3.875H7.625C8.17728 3.875 8.625 4.32272 8.625 4.875C8.625 5.42728 8.17728 5.875 7.625 5.875H4.875V8.625C4.875 9.17728 4.42728 9.625 3.875 9.625C3.32272 9.625 2.875 9.17728 2.875 8.625V4.875Z"
        fill={iconColor}
      />
      <Path
        d="M9.75 8.625C9.75 8.07272 9.30228 7.625 8.75 7.625C8.19772 7.625 7.75 8.07272 7.75 8.625V15.375C7.75 15.9273 8.19772 16.375 8.75 16.375C9.30228 16.375 9.75 15.9273 9.75 15.375V8.625Z"
        fill={iconColor}
      />
      <Path
        d="M16.25 7.625C16.8023 7.625 17.25 8.07272 17.25 8.625V15.375C17.25 15.9273 16.8023 16.375 16.25 16.375C15.6977 16.375 15.25 15.9273 15.25 15.375V8.625C15.25 8.07272 15.6977 7.625 16.25 7.625Z"
        fill={iconColor}
      />
      <Path
        d="M13.5 8.625C13.5 8.07272 13.0523 7.625 12.5 7.625C11.9477 7.625 11.5 8.07272 11.5 8.625V15.375C11.5 15.9273 11.9477 16.375 12.5 16.375C13.0523 16.375 13.5 15.9273 13.5 15.375V8.625Z"
        fill={iconColor}
      />
    </Svg>
  );
};

export default BarCodeIcon;
